import { ref, toRef } from 'vue'
import type { Ref } from 'vue'

// object is what Vue uses in the typing for `toRef` so I'm using it here
export function useControlledState<T extends object, K extends keyof T>(
    key: K,
    props: T,
    defaultState: T[K]
): {
    isControlled: boolean
    stateRef: Ref<Exclude<T[K], undefined>>
} {
    const isControlled = props[key] !== undefined
    const stateRef = (
        isControlled ? toRef(props, key) : ref(defaultState)
    ) as Ref<Exclude<T[K], undefined>>

    return {
        isControlled,
        stateRef
    }
}
